import { SET_ALERT_NOTIFICATION } from "constants/ActionTypes";
import { useDispatch } from "react-redux";

export const useAlert = () => {
  const dispatch = useDispatch();

  const show = (payload, options = {}) => {
    dispatch({
      type: SET_ALERT_NOTIFICATION,
      payload: {
        ...payload,
        ...options,
      },
    });
  };

  const success = (msg, options = {}) => {
    dispatch({
      type: SET_ALERT_NOTIFICATION,
      payload: {
        type: "success",
        msg,
        ...options,
      },
    });
  };

  const error = (msg, options = {}) => {
    dispatch({
      type: SET_ALERT_NOTIFICATION,
      payload: {
        type: "error",
        msg,
        ...options,
      },
    });
  };

  const close = (msg, options = {}) => {
    dispatch({
      type: SET_ALERT_NOTIFICATION,
      payload: null,
    });
  };
  return { show, success, error, close };
};
